import React from 'react';
import {Grid, Typography} from '@mui/material';
import Dialog from 'components/Dialog';
import AsyncContainer from 'components/AsyncContainer';
import Panel from 'components/Panel';
import {Trans, useTranslation} from 'react-i18next';
import Button from 'components/Button';
import {PrimaryButton} from 'components/buttons/PrimaryButton';
import {INav} from 'features/layout/redux/helpers/FoldersHelper';
import {useDispatch, useSelector} from 'react-redux';
import {default as transactionsSelectors} from 'redux/transactions/selectors';
import {unpackId} from 'common/diplomatIdUtil';
import {useTransactionsRefs} from 'redux/transactions/hooks/useTransactionsRefs';
import {useDeleteApi} from 'common/hooks/useDeleteApi';
import api from 'api';
import {layoutActions} from 'features/layout/redux';
import TransactionReferencesAlert from '../partners/TransactionReferencesAlert';
import {useSynchronizationsRefs} from 'redux/synchronizations/hooks/useSynchronizationsRefs';
import {pageActions} from 'features/layout/CommonPage/redux';

type DeleteTransactionDialogProps = {
   data: INav;
   onClose: () => void;
};

const DeleteTransactionDialog = ({data, onClose}: DeleteTransactionDialogProps) => {
   const {t} = useTranslation();

   const {id} = unpackId(data.id);
   const transactions = useTransactionsRefs(id, 'transaction');
   const synchronizations = useSynchronizationsRefs(id, 'transaction');

   const dispatch = useDispatch();
   const onSuccess = () => {
      dispatch(layoutActions.loadTreeNav());
      dispatch(pageActions.flushData());
      onClose();
   };
   const {request: onConfirm} = useDeleteApi(api.transactions + `/${id}`, {
      onSuccess,
   });

   const isTransactionsFetching = useSelector(transactionsSelectors.isFetching);
   const hasReferences = transactions.length || synchronizations.length;
   const objectName = t('Transaction');
   return (
      <Dialog maxWidth="sm" header={t('Delete Transaction')} close={onClose}>
         <AsyncContainer loading={isTransactionsFetching}>
            <Panel root>
               {hasReferences ? (
                  <TransactionReferencesAlert
                     data={data}
                     objectName={objectName}
                     transactions={transactions}
                     synchronizations={synchronizations}
                  />
               ) : (
                  <Typography>
                     <Trans t={t}>
                        Do you really want to delete {{objectName}} "{{name: data.name}}"?
                     </Trans>
                  </Typography>
               )}
            </Panel>
            <Grid container spacing={2} justifyContent={'center'}>
               <Grid item>
                  <PrimaryButton onClick={() => onConfirm()}>{t('OK')}</PrimaryButton>
               </Grid>
               <Grid item>
                  <Button onClick={onClose}>{t('Cancel')}</Button>
               </Grid>
            </Grid>
         </AsyncContainer>
      </Dialog>
   );
};

export default DeleteTransactionDialog;
